export default `p -= round( p );
  float s = 3.0;
  float e = 0.0;
  for( int i=0;i++ < 8; p = p / e + 2.0 )
    p = abs( p ) - 1.5,
    s /= e = min( dot( p, p ), 0.4 );
  return e = length( p.yz ) / s;
}`